import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaColors, YodaFontSize, YodaJustifyContent, YodaSpacing } from 'yoda-ui/yodaTheme';

export const headerWrapperStyle: SxProps<Theme> = () => ({
  marginBottom: '32px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: YodaJustifyContent.spaceBetween,
  alignItems: YodaJustifyContent.flexStart,
  gap: YodaSpacing.small,

  '& .MuiBox-root': {
    marginBottom: 0,
  },

  '@media (min-width: 1600px)': {
    flexDirection: 'row',
  },
});

export const buttonStyle = {
  justifyContent: 'start',
  marginBottom: YodaSpacing.small,
  fontSize: YodaFontSize.small,
  color: YodaColors.blue7,
  width: 'fit-content',

  '&:hover': {
    color: YodaColors.blue8,
  },
};
